import { usePermissions } from '~/entities/viewer'
import { canShowObject } from '~/shared/lib/utils'

type Header = { label: string; to: string; parent?: string }

export const useHeader = (): Header[] => {
  const {
    canPenaltyView,
    canCompaniesView,
    canOtherChargesView,
    canSettingsView,
    canTollRoadView,
  } = usePermissions()

  return [
    ...canShowObject(canPenaltyView, {
      label: 'Штрафы',
      to: '/penalties',
    }),
    ...canShowObject(canOtherChargesView, {
      label: 'Прочие начисления',
      to: '/other-charges',
    }),
    ...canShowObject(canTollRoadView, {
      label: 'Проезды',
      to: '/toll-roads',
    }),
    ...canShowObject(canCompaniesView, {
      label: 'Организации',
      to: '/companies',
    }),
    ...canShowObject(canSettingsView, {
      label: 'Настройки',
      to: '/settings/employees',
      parent: '/settings',
    }),
  ]
}
